/**
 * `@zep/crm/quotes` — CRM 견적 API 의 HTTP 계층.
 *
 * React 도 react-query 도 없다. 앱마다 react-query 메이저가 달라(quiz v5 / web v4)
 * 훅은 공유할 수 없고, 견적서 본문도 서비스마다 달라 공유할 게 없다. 여기 있는 건
 * 세 서비스가 실제로 같은 것 — 경로·에러 shape·응답 계약뿐이다.
 */
export {
  CrmApiError,
  type CrmClient,
  type CrmClientOptions,
  type CrmErrorBody,
  createCrmClient,
} from './crmClient';
export {
  type CrmPublicQuoteResponse,
  type CrmQuoteService,
  type CrmQuoteSubmitResponse,
  crmQuotePublicPath,
  crmQuoteSubmitPath,
  fetchPublicCrmQuote,
  submitCrmQuote,
} from './quoteApi';
